<template>
    <div>
        <Menu mode="horizontal" :active-name="currentActiveName" class="wrapper-header-nav">            
        <router-link to="/" class="wrapper-header-nav-logo">
            <img src="../assets/header_banner.png" alt="">
        </router-link>
        <div class="wrapper-header-nav-list">
            <MenuItem name="4">
                <Icon type="ios-call-outline" size="28" color="#2196F3"/>
                <span style="color: #2196F3;line-height: 4.5;font-weight: 550;padding-left: 0;font-size:14px;">4008-337-009</span>                
            </MenuItem>
            <!-- <MenuItem name="1">
                <Icon type="ios-paper" />
                登录
            </MenuItem>
            <MenuItem name="2">
                <Icon type="ios-people" />
                注册
            </MenuItem> -->
                <RadioGroup type="button">
                    <Radio v-on:click.native='changeLanguage("zh")'>中文</Radio>
                    <Radio v-on:click.native='changeLanguage("en")'>English</Radio>
                </RadioGroup>
            
        </div>
    </Menu>
    </div>
</template>

<script>
import Vue from 'vue'

import iView from 'iview'
//多语言
// importing iView on demand
import { locale, Page } from 'iview';
import enlang from 'iview/dist/locale/en-US';
import cnlang from 'iview/dist/locale/zh-CN';


export default {
  name: 'HeaderNavMenu',
  props: {
    currentActiveName: String
  },
  methods: {
      //语言切换
    changeLanguage: function (lang) {
        this.$i18n.locale=lang;
        localStorage.setItem("language", lang);
    }
  }
}
</script>

<style>
.wrapper-header-nav {
    width: 100%;
    height: 65px;
    margin: 0 auto;
}
.wrapper-header-nav-logo {
    height: 50px;
    margin-top: 8px;
    float: left;
    margin-left: 80px;
}
.wrapper-header-nav-list {
    height: inherit;
    float: right;
    margin-right: 50px;
}
</style>

